import gql from 'graphql-tag';

const createBadgingBlacklistMutation = gql`
  mutation CreateBadgingBlacklist($input: CreateBadgingBlacklistInput!) {
    createBadgingBlacklist(input: $input) {
      success
      errors
      badgingBlacklistEntry {
        id
        sellerNumber
        vin
        expirationDate
        notes
        status
        createdAt
      }
    }
  }
`;

export default createBadgingBlacklistMutation;
